import { IComboBox } from "@interfaces/IComboBox";
import { IDriver } from "@interfaces/IDriver";
import { IGeofence } from "@interfaces/IGeofences";
import { IVehicle } from "@interfaces/IVehicle";
import { TimeFilterType } from "@reports/enums/TimeFilterType";
import { UnitConversionType } from "@services/unitConversion.service";
import { IGroup } from "../../resourceManagement/groups/_models/IGroup";

export enum ReportParameterType {
    MinimumDistance = 0,
    RouteId = 1,
    JourneyId = 2,
    GeofenceVisitId = 3,
    TrailerAssociationId = 4,
    CommonEventId = 5,
    ExcludeTrailers = 6,
    ShowNoDriver = 7,
    IncludeNoDriver = 8,
    MinimumSpeed = 9,
    MinimumIdleTime = 10,
    AlcolockRecordPlotId = 11,
    ExcludeGpsJourneys = 12,
    ExcludeCanJourneys = 13,
    ShowOnlyAlcolockEventGroup = 14,
    ReasonCode = 15,
    RoadType = 16,
    InputRecordHistoryId = 17,
    TemperatureOutOfBoundId = 18,
    IntersectingGeofenceVisitTimes = 19,
    MinimumFuelLevelChange = 20,
    ExcludeInconsequentialJourneys = 21,
    ShowRowsWithNoData = 22,
    MinimumFuelUsed = 23,
    IncludeOnlyInstalledCameras = 24,
    CameraEventId = 25,
    InclusiveGroupFiltering = 26,
    HideParameterList = 27,
    VehicleType = 28,
    PercentageOverSpeedLimit = 29,
    ShowVehiclesWithNoUnit = 30,
    ShowVehiclesNotTracking = 31,
    ShowInactiveDrivers = 32,
    HideMinorCameraEvents = 33,
    ShowOnlyDownloadedVideos = 34,
    GeofenceCategory = 35,
    ShowOnlyBusinessJourneys = 36,
    FormId = 37,
    FormFieldId = 38,
    FormFieldValueId = 39,
    MinimumEventTime = 40,
    ShowDurationPastEndTime = 41,
    ShowArchivedEvents = 42,
    FilterVehicleRowsByVehicleType = 43,
    TrailerId = 44,
    HiddenProbes = 45,
    WithoutComparisonOperator = 46,
    LatLongOnly = 47,
    ReportTimeFilter = 48,
    EmptyRunningJourneysOnly = 49,
    MinimumDurationOverWeight = 50,
    ReportOnSingleBound = 51,
    OmitTotalsRows = 52,
    OutOfBoundsAxleRecordId = 53,
    ShowOnlyRowsWithVor = 54,
    AlertRecordId = 55,
    AlertReviewId = 56,
    OnlyAcknowledgedAlerts = 57,
    OnlyUnacknowledgedAlerts = 58,
    TemperatureRecordId = 59,
    CompositeLocationId = 60,
    IncludeOpenAlertsInCalculations = 61,
    AlertResolutionCodeId = 62,
    InProgressGeofenceVisits = 63,
    ExcludeVehiclesWithoutActivity = 64,
    ForceDisplayAllDrivingMetricValues = 65,
    LatestCameraOnlineHistory = 66,
    CreateUnassignedGroupRow = 67,
    IncludeUnassigned = 68,
    LatestBrakePerformanceHistory = 69,
    LatestBrakePerformanceValue = 70,
    BrakePerformanceValueId = 71,
}

export enum ReportParameterValueType {
    Text,
    Number,
    Date,
    Select,
    Boolean,
    TemperatureProbes
}

export interface IReportParameter {
    ParameterType: ReportParameterType;
    Value: any;
    Active: boolean;
}

export interface IReportParameterDefinitions {
    reportType: string;
    reportParameterDefinition: IReportParameterDefinition[];
}

export interface IReportParameterDefinition extends IReportParameter {
    parameterName: string;
    valueType: ReportParameterValueType;
    maxValue?: any;
    minValue?: any;
    defaultValue?: any;
    stepSize?: number;
    options?: IComboBox[];
    conversionType?: UnitConversionType;
    conversionLabel?: string;

    // ---

    displayValue?: any;
    formControlName?: string;
}

export interface IReportParameters {
    Start?: Date;

    End?: Date;

    DriverId?: number;
    DriverGroupId?: number;

    VehicleId?: number;
    VehicleGroupId?: number;

    GeofenceId?: number;
    GeofenceGroupId?: number;

    PrimaryReportParameter?: IReportParameter;
    CustomParameters?: IReportParameter[];

    IncludeRecordsWithNoData?: boolean;

    TimeFilterStart?: string;
    TimeFilterEnd?: string;
    TimeFilterType?: TimeFilterType;

    TagIds?: number[];

    Driver?: IDriver;
    Vehicle?: IVehicle;
    Geofence?: IGeofence;

    VehicleGroup?: IGroup;
    DriverGroup?: IGroup;
    GeofenceGroup?: IGroup;

    TranslatedTitle?: string;
    //groupBy?: GroupBy;
}
